import { ISSUES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const issuesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getIssues: build.query({
      query: (params = {}) => ({ url: ISSUES.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Issue', result),
    }),
    getIssueById: build.query({
      query: (issueId) => ({ url: ISSUES.BY_ID(issueId), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'Issue', id }],
    }),
    createIssue: build.mutation({
      query: (issueData) => ({
        url: ISSUES.CREATE,
        method: 'POST',
        data: issueData,
      }),
      invalidatesTags: [{ type: 'Issue', id: 'LIST' }],
    }),
    updateIssueStatus: build.mutation({
      query: ({ issueId, statusData }) => ({
        url: ISSUES.UPDATE_STATUS(issueId),
        method: 'PUT',
        data: statusData,
      }),
      invalidatesTags: (_r, _e, { issueId }) => [
        { type: 'Issue', id: issueId },
        { type: 'Issue', id: 'LIST' },
      ],
    }),
    assignIssueToUser: build.mutation({
      query: ({ issueId, userId }) => ({
        url: ISSUES.ASSIGN_USER(issueId),
        method: 'POST',
        data: { assignee_id: userId },
      }),
      invalidatesTags: (_r, _e, { issueId }) => [
        { type: 'Issue', id: issueId },
        { type: 'Issue', id: 'LIST' },
        { type: 'Issue', id: `assigned-${issueId}` },
      ],
    }),
    deleteIssue: build.mutation({
      query: (issueId) => ({ url: ISSUES.BY_ID(issueId), method: 'DELETE' }),
      invalidatesTags: (_r, _e, issueId) => [
        { type: 'Issue', id: issueId },
        { type: 'Issue', id: 'LIST' },
      ],
    }),
    getIssueAssignedUsers: build.query({
      query: (issueId) => ({
        url: ISSUES.ASSIGNED_USERS(issueId),
        method: 'GET',
      }),
      providesTags: (_r, _e, id) => [{ type: 'Issue', id: `assigned-${id}` }],
    }),
  }),
});

export const {
  useGetIssuesQuery,
  useLazyGetIssuesQuery,
  useGetIssueByIdQuery,
  useLazyGetIssueByIdQuery,
  useCreateIssueMutation,
  useUpdateIssueStatusMutation,
  useAssignIssueToUserMutation,
  useDeleteIssueMutation,
  useGetIssueAssignedUsersQuery,
  useLazyGetIssueAssignedUsersQuery,
} = issuesApi;
